import { useEffect } from 'react'

// Протяжка таблиц сетевых отчётов мышью: зажал левую кнопку на таблице (.chain-scroll) и тянешь —
// таблица прокручивается в обе стороны. Работает во всех таблицах экрана и его модалок: слушатель
// один на документ, ставит его ChainFilterBar. Своя протяжка (тепловая карта часов) помечается
// data-chain-drag="off". Нажатия на кнопках, ссылках и полях не перехватываем, а клик после
// протяжки гасим — иначе отпущенная кнопка открывала бы расшифровку ячейки под курсором.

const INTERACTIVE_SELECTOR = 'input, textarea, select, button, a, label, [role="button"], .dropdown, .chain-th-sort'
const DRAG_THRESHOLD = 5

function useChainDragScroll() {
	useEffect(() => {
		let state = null

		function onMouseDown(e) {
			if (e.button !== 0) return
			const box = e.target?.closest?.('.chain-scroll')
			if (!box || box.dataset.chainDrag === 'off') return
			if (e.target.closest(INTERACTIVE_SELECTOR)) return
			state = { box, x: e.clientX, y: e.clientY, left: box.scrollLeft, top: box.scrollTop, dragged: false }
		}

		function onMouseMove(e) {
			if (!state) return
			const dx = e.clientX - state.x
			const dy = e.clientY - state.y
			if (!state.dragged && Math.abs(dx) + Math.abs(dy) > DRAG_THRESHOLD) {
				state.dragged = true
				window.getSelection()?.removeAllRanges()
				state.box.classList.add('chain-dragging')
			}
			if (state.dragged) {
				e.preventDefault()
				state.box.scrollLeft = state.left - dx
				state.box.scrollTop = state.top - dy
			}
		}

		function onMouseUp() {
			if (!state) return
			state.box.classList.remove('chain-dragging')
			// Клик, который придёт сразу после протяжки, гасим один раз
			if (state.dragged) {
				const swallow = (event) => {
					event.preventDefault()
					event.stopPropagation()
				}
				document.addEventListener('click', swallow, { capture: true, once: true })
				setTimeout(() => document.removeEventListener('click', swallow, { capture: true }), 0)
			}
			state = null
		}

		document.addEventListener('mousedown', onMouseDown)
		document.addEventListener('mousemove', onMouseMove)
		document.addEventListener('mouseup', onMouseUp)
		return () => {
			document.removeEventListener('mousedown', onMouseDown)
			document.removeEventListener('mousemove', onMouseMove)
			document.removeEventListener('mouseup', onMouseUp)
		}
	}, [])
}

export default useChainDragScroll
